import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarVerracosExcel/descargarPlantillaExcelVerracosExcel`, method: 'GET', body: null, token: token})
}
